import classNames from 'classnames';
import React, { forwardRef, Ref } from 'react';
import { NavLink, NavLinkProps, useMatch } from 'react-router-dom';
import { UDTextType } from '../text';

export type IUDNavLinkProps = {
  type?: UDTextType;
  disabled?: boolean;
  checkPath?: string;
  /**
   * Активность, заданная вызывающим. Без него ссылка активна, когда адрес совпал с `checkPath`;
   * `false` гасит её и при совпадении — когда паттерн шире, чем раздел (`/manager/*` и `/manager/queue`).
   */
  active?: boolean;
  variant?: 'primary' | 'secondary';
} & NavLinkProps;

const UDNavLink = forwardRef<HTMLAnchorElement, IUDNavLinkProps>((props: IUDNavLinkProps, ref: Ref<HTMLAnchorElement>) => {
  const { type = 'callout', disabled, className, checkPath, active, variant = 'primary', ...otherProps } = props;

  const { to } = otherProps;
  const url = checkPath ?? (typeof to === 'string' ? to : to.pathname);
  const matched = useMatch(url ?? '');
  const isActive = active ?? Boolean(matched);

  return (
    <NavLink
      {...otherProps}
      ref={ref}
      className={() =>
        classNames('link', 'text', type, className, variant, {
          disabled,
          active: isActive,
        })
      }
    />
  );
});

// Добавляем отображаемое имя для улучшения отладки
UDNavLink.displayName = 'UDNavLink';

export default UDNavLink;
